import ActionBtn from 'components/ActionBtn';
import { useSocketContext } from 'hooks/useSocket';
import { useNavigate } from 'react-router-dom';
import storage from 'utils/sessionStorage';
import useUpdateTicket from '../useUpdateTicket';
import shopSelectors from 'services/shop/selectors';

const ButtonMultipleCard = () => {
  const updateTicket = useUpdateTicket();
  const navigate = useNavigate();
  const socketContext = useSocketContext();
  const allSetting = shopSelectors.data.allSetting();

  const onMultiCard = async () => {
    const rest: { billId: string } | null = await updateTicket();
    if (!rest) return;

    const billId = rest.billId;
    navigate(`/store/${storage.shop_id.get()}/ticket/payment/multiple-card/cashier/${billId}`);
    socketContext.switchCustomerScreen(`/store/${storage.shop_id.get()}/ticket/payment/multiple-card/customer/${billId}`);
  };

  if (!allSetting?.enableMultipleCards) return null;

  return (
    <ActionBtn icon='multiCards' ntype='YELLOW' small label='Multi-Cards' onClick={onMultiCard} />
  );
};

export default ButtonMultipleCard;
